import React from 'react';

const Textarea = ({ label, error, className = '', rows = 4, ...props }) => (
  <div className={className}>
    {label && <label className="block text-sm font-medium text-slate-300 mb-2">{label}</label>}
    <textarea
      rows={rows}
      className={`
        w-full bg-slate-700/50 border rounded-xl py-2.5 px-4 text-white 
        placeholder-slate-500 focus:outline-none focus:border-emerald-500 transition-colors resize-none
        ${error ? 'border-rose-500' : 'border-slate-600'}
      `}
      {...props}
    />
    {error && <p className="mt-1 text-sm text-rose-400">{error}</p>}
  </div>
);

export default Textarea;
